import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@airbus/components-react/components/Button'
import ModalAskReason from './modalAskReason'

type Props = {
  lang: string
  idCommand: string
  actionName: string
  onUserActionCompleted: (action: string) => void
}

const Refusal = ({ lang, idCommand, actionName, onUserActionCompleted }: Props) => {
  const { t } = useTranslation()

  // State of the modal for inputting the reason for a refusal
  const [modalReasonOpened, setModalReasonOpened] = useState(false)

  return (
    <div>
      <Button variant='secondary' onClick={() => setModalReasonOpened(true)}>
        <div>{t('9220626')}</div>
      </Button>

      <ModalAskReason
        title={t('9500145').replace('{0}', idCommand)}
        label={t('9500151')}
        lang={lang}
        idCommand={idCommand}
        isReasonCompulsory={true}
        isOpened={modalReasonOpened}
        onCloseModal={() => setModalReasonOpened(false)}
        actionName={actionName}
        onUserActionCompleted={onUserActionCompleted}
      />
    </div>
  )
}

export default Refusal
